<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Create an Email Account
        </gg-card-header>
        <gg-card-text>
          <create-email />
        </gg-card-text>
      </gg-card>
    </v-col>

    <email-table />
<!--      <default-account/>-->
<!--      <configuration/>-->
  </v-row>
</template>

<script>
import CreateEmail from '@/components/Services/Hosting/Shared/Email/Accounts/CreateEmail'
import EmailTable from '@/components/Services/Hosting/Shared/Email/Accounts/EmailsTable'
// import DefaultAccount from '@/components/Services/Hosting/Shared/Email/Accounts/DefaultAccount'
// import Configuration from '@/components/Services/Hosting/Shared/Email/Accounts/Configuration'

export default {
  name: 'EmailAccountsView',
  components: {
    CreateEmail, EmailTable, // DefaultAccount, Configuration,
  },
}
</script>
